/* eslint-disable import/prefer-default-export */

export const AUTOTESTS_ID_ATTRIBUTE = 'data-autotests-id';
